import { AHIcon, AHIconProps, AHText, Box, Circle } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoListItemContact_todo$key } from "./__generated__/TodoListItemContact_todo.graphql";

import { TodoFeedbackStatusText } from "../../Todo/TodoContact";

export function TodoListItemContact(props: {
  todo: TodoListItemContact_todo$key;
  expanded?: boolean;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemContact_todo on Todo {
        contact {
          name
          phoneNumber
          email
        }
        feedbackStatus
      }
    `,
    props.todo
  );

  const iconProps = {
    color: "washedText",
    size: "xsmall",
  } satisfies Partial<AHIconProps>;

  const hasFeedbacks = todo.feedbackStatus === "FEEDBACK_COMPLETED";
  if (!todo.feedbackStatus) {
    return null;
  }
  return (
    <Box
      gap="xsmall"
      borderColor="border-primary"
      cornerRadius="full"
      space="xxsmall"
      spaceHorizontal="xsmall"
      color="surface"
      style={{ flexDirection: "row", borderWidth: 1, alignItems: "center" }}
    >
      {todo.contact?.phoneNumber ? (
        <AHIcon type="phone" {...iconProps} />
      ) : null}
      {todo.contact?.email ? <AHIcon type="email" {...iconProps} /> : null}
      {props.expanded ? (
        <AHText type="info-small" color="washedText">
          <TodoFeedbackStatusText feedbackStatus={todo.feedbackStatus} />
        </AHText>
      ) : null}
      <Circle
        size="dot"
        color={hasFeedbacks ? "status-positive" : "status-feedback-negative"}
      />
    </Box>
  );
}
